import React from 'react';
import banImg from "../../assets/images/about/about-banner.webp";

function BannerAbout() {

  return (
    <section className='banner-about'>
        
        <div className='banner-caption-sec'>
            <div className='container'>
                <div className='caption-banner'>
                    <div className='ban-caption'>
                        <h1 className='big-ttl'>Company Overview</h1>
                        <p className='sm-para big-para'>Choice TechLab Solutions Pvt. Ltd.</p>
                        <p className='sm-para'>Year of establishment: 2016</p>
                        <p className='abt-description'>Choice TechLab (CTL) provides innovative technology solutions to help businesses across diverse sectors thrive in today's digital age. From cutting-edge digital transformations to tailored software products and applications, we empower our clients to unlock their full potential.</p>
                        <div className='shape-animation'>
                            <div className='rectangle'>
                                <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.3672 3.92492C16.357 1.57499 20.1445 2.26031 21.1847 5.1585L27.0429 21.4806C28.0831 24.3788 25.5959 27.3162 22.5659 26.768L5.50139 23.6803C2.47139 23.132 1.17114 19.5093 3.16095 17.1594L14.3672 3.92492Z" fill="white" stroke="#E45525" strokeWidth="4"/>
                                </svg>
                            </div>
                            <div className='circle-1'></div>
                        </div>
                        <div className='shape-animation2'>
                            <div className='circle-2'></div>
                            <div className='circle-3'></div>
                        </div>
                        
                    </div>
                    <div className='ban-img'>
                        <img src={banImg} alt='' width={476} height={461} />
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default BannerAbout;
